import {UTCDate} from "@date-fns/utc";
import {differenceInSeconds} from "date-fns";

import {isCheckPending} from "@/pages/checks/analysis/utils.ts";
import {State} from "@/pages/checks/constants.ts";

export interface CheckStateProps {
  state_is_up: boolean;
  created_at: string;
  is_paused: boolean;
}

export const getCheckState = ({state_is_up, is_paused, created_at}: CheckStateProps): State => {
  let state = state_is_up ? State.Up : State.Down;
  const created = differenceInSeconds(new UTCDate(), created_at);
  if (isCheckPending(state_is_up, created)) {
    state = State.Pending;
  }
  if (is_paused) {
    state = State.Paused;
  }
  return state;
};
